import React, { useEffect, useState } from "react";
import { DataForm } from "../../../../../libs/react-mpk/components";
import { number } from "../../../../../libs/react-mpk/services";
import t from "counterpart";
import { storage } from "../../../../../services";
import { inject, observer } from "mobx-react";

const { inputTypes } = DataForm;

const CheckList = ({ defaultData = {}, ...props }) => {
  const indukData = storage.get(storage.keys.SPT_1770_INDUK);
  const profile = storage.get(storage.keys.SPT_1770_PROFILE);
  const [data, setData] = useState(defaultData);
  useEffect(() => {
    setData({ ...defaultData, ...getUpdateData(defaultData) });
  }, []);
  const getUpdateData = (data) => {
    return data;
  };

  return (
    <DataForm
      baseId={`spt-1770-induk-CheckList`}
      className="mpk-padding-NONE padding-all"
      asDialog={false}
      defaultData={data}
      definitions={[
        {
          inputType: inputTypes.CHECKBOX,
          label: t.translate(`modules.submission.sptForm.1770.Induk.ChkGa`),
          key: "checkGa",
          show: true,
        },
        {
          inputType: inputTypes.CHECKBOX,
          label: t.translate(`modules.submission.sptForm.1770.Induk.ChkGb`),
          key: "checkGb",
          disabled: true,
        },
        {
          inputType: inputTypes.CHECKBOX,
          label: t.translate(`modules.submission.sptForm.1770.Induk.ChkGc`),
          key: "checkGc",
          disabled: true,
        },
        {
          inputType: inputTypes.CHECKBOX,
          label: t.translate(`modules.submission.sptForm.1770.Induk.ChkGd`),
          key: "checkGd",
        },
        {
          inputType: inputTypes.CHECKBOX,
          label: t.translate(`modules.submission.sptForm.1770.Induk.ChkGe`),
          key: "checkGe",
          disabled: true,
        },
        {
          inputType: inputTypes.CHECKBOX,
          label: t.translate(`modules.submission.sptForm.1770.Induk.ChkGf`),
          key: "checkGf",
        },
        {
          inputType: inputTypes.INPUT,
          label: t.translate(`modules.submission.sptForm.1770.Induk.IsiChkGf`),
          key: "isiCheckGf",
          show: (item) => item.checkGf,
        },
        {
          inputType: inputTypes.CHECKBOX,
          label: t.translate(`modules.submission.sptForm.1770.Induk.ChkGg`),
          key: "checkGg",
        },
        {
          inputType: inputTypes.CHECKBOX,
          label: t.translate(`modules.submission.sptForm.1770.Induk.ChkGh`),
          key: "checkGh",
        },
        {
          inputType: inputTypes.INPUT,
          label: t.translate(`modules.submission.sptForm.1770.Induk.IsiChkGh`),
          key: "isiCheckGh",
          show: (item) => item.checkGh,
          disabled: profile.fghs ? true : false,
        },
        {
          inputType: inputTypes.CHECKBOX,
          label: t.translate(`modules.submission.sptForm.1770.Induk.ChkGi`),
          key: "checkGi",
          disabled: true,
        },
        {
          inputType: inputTypes.CHECKBOX,
          label: t.translate(`modules.submission.sptForm.1770.Induk.ChkGj`),
          key: "checkGj",
        },
        {
          inputType: inputTypes.CHECKBOX,
          label: t.translate(`modules.submission.sptForm.1770.Induk.ChkGk`),
          key: "checkGk",
        },
        {
          inputType: inputTypes.CHECKBOX,
          label: t.translate(`modules.submission.sptForm.1770.Induk.ChkGl`),
          key: "checkGl",
        },
        {
          inputType: inputTypes.INPUT,
          label: t.translate(`modules.submission.sptForm.1770.Induk.IsiChkGl`),
          key: "isiCheckGl",
          show: (d) => d.checkGl,
        },
      ]}
      onBeforeChange={(key, value) => {
        if (key === "isiCheckGf") value = value.replace(/\D/gi, "");
        return value;
      }}
      onChange={(data, key, value) => {
        if (key === "checkGh") {
          if (profile.fghs && value) {
            data.isiCheckGh = "Lampiran Perhitungan Sendiri";
          } else {
            data.isiCheckGh = "";
          }
        }
        const update = getUpdateData(data);
        setData({ ...data, ...update });
        return { ...data, ...update };
      }}
      onSubmit={(data, callback) => {
        if (profile.fghs == 1) {
          if (data.checkGh == true) {
            props.onSave({ checkList: data });
            callback(t.translate("sentence.savedItem"), false);
          } else {
            callback(
              t.translate(
                "modules.submission.sptForm.1770.Induk.validasiPenghitunganSendiri"
              ),
              true
            );
          }
        } else {
          props.onSave({ checkList: data });
          callback(t.translate("sentence.savedItem"), false);
        }
      }}
      submitLabel={t.translate("column.save")}
    />
  );
};

export default inject("envStore")(observer(CheckList));
